export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEJS1NDLUVVQy1IYRChogG+eAEAvnoAAMEAAgK+ewEAvn4EC75/LQC/C4M1AL8MBgG/DQIAvw8BAL8QCwW/ERsAvxcBAL8YAQC/GRsDvxo=", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/KSC-EUC-V.bcmap
// module id = 669
// module chunks = 502